import React, { useState } from 'react'
import styled from 'styled-components'
import Typography from '@ntuctech/devex-tangram/Typography'
import DiscountIcon from '../../icons/Discount'
import ArrowIcon from '../../icons/svg/arrow-down.svg'

const StyledDiscountIcon = styled(DiscountIcon)`
  font-size: 1.125rem;
  margin-right: 0.125rem;
`

const BenefitsTitle = styled.div`
  font-weight: 600;
  display: flex;
  align-items: center;
  margin-bottom: 0.25rem;
  font-size: 0.875rem;
  justify-content: space-between;
  padding-top: 1rem;
  padding-left: 0.2rem;
  ${props =>
    props.isMember && 'border-top: 0.1rem solid #cccccc; cursor: pointer;'}
`

const Left = styled.div`
  display: flex;
  align-items: center;

  h6 {
    margin-left: 0.5rem;
  }
`

const BenefitsContent = styled.div`
  margin-bottom: 1rem;
  padding: 0 0.2rem;

  span {
    display: block;
    color: #696969;
    font-style: italic;
    font-size: 0.8rem;
    margin-top: 1rem;
    margin-bottom: 0;
  }

  .header {
    color: inherit;
    font-weight: 600;
    font-style: italic;
    margin-top: 0.5rem;
  }

  h4 {
    font-weight: 900;
    margin-top: 0.5rem;
  }

  ul {
    margin-bottom: 0.5rem;
  }

  li:before {
    content: '•';
    margin-right: 0.2rem;
  }
`

const ArrowImg = styled.img`
  padding-top: 0.3rem;
  transition-duration: 0.4s;
  transition-property: transform;
  outline: 0;
  transform: translateY(-0.1rem);

  &[data-toggle='true'] {
    transform: translateY(0.1rem) rotate(180deg);
  }
`

const Benefits = ({ content, isMember }) => {
  const [toggle, setToggle] = useState(false)

  const showContent = content && (!isMember || toggle)

  return (
    <React.Fragment>
      <BenefitsTitle
        data-testid="toggle-button"
        isMember={isMember}
        onClick={() => setToggle(!toggle)}
      >
        <Left>
          <StyledDiscountIcon />
          <Typography variant="h6">Exclusive membership benefits</Typography>
        </Left>
        {isMember && (
          <ArrowImg
            src={ArrowIcon}
            data-testid="toggle-icon"
            data-toggle={toggle}
          />
        )}
      </BenefitsTitle>
      <BenefitsContent>
        {showContent && <div dangerouslySetInnerHTML={{ __html: content }} />}
      </BenefitsContent>
    </React.Fragment>
  )
}

export default Benefits
